module.exports = __webpack_public_path__ + "static/media/advertise1.604931e5.png";